import { render, staticRenderFns } from "./AdminStates.vue?vue&type=template&id=6a956920"
import script from "./AdminStates.vue?vue&type=script&lang=js"
export * from "./AdminStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports